import Note from '../Note';
import _ from 'lodash';
import withProbability from './withProbability';

export default function randomizeStartingNote(note, instrument, programmer) {
  const possibilities = [note];

  if (!note || withProbability(.4)) {
    possibilities[0] = Math.floor(Math.random() * (instrument.notes.length - 1))
    console.log('Starting pattern at a random note ');
  }

  if (withProbability(.4)) {
    let startingNoteIndex = possibilities[0].noteIndex;
    let addedOctave = startingNoteIndex + programmer.octaveLength;
    let subtractedOctave = startingNoteIndex - programmer.octaveLength;

    if (instrument.notes[addedOctave]) possibilities.push(addedOctave);
    if (instrument.notes[subtractedOctave]) possibilities.push(subtractedOctave);
    if (subtractedOctave < 0) debugger
  }

  return new Note(_.sample(possibilities), instrument);
}



// WEBPACK FOOTER //
// ./src/lib/randomizeStartingNote.js